import store from "../index.js";
import router from "../../router/index";
import api from "../../utils/api";
import SubscribeConstant, {
  initialSubscribeInfoState,
  initialSubscribeAddressChangeState,
} from "../../mixins/subscribe/const/subscribeConstant";
import SubscribeAcConstant from "@/mixins/subscribe/const/subscribeAcConstant.js";
import { callGetApi, callPostApi, callPatchApi, callDeleteApi } from "@/utils/apiWrapper";

export const modules = {
  store,
};

export const state = {
  _subscribe: [],
  _comment: {},
  _history: [],
  _cards: [],
  _items: {
    act_score: 0,
  },
  _info: { ...initialSubscribeInfoState },
  _addressChange: { ...initialSubscribeAddressChangeState },
  _reservation: [],
};

export const mutations = {
  [SubscribeConstant.ADD_CANCEL]: (state, payload) => {
    state._reservation = [];
    state._reservation = payload;
  },
  [SubscribeConstant.ADD_REASON]: (state, payload) => {
    for (let i = 0; i < state._reservation.length; i++) {
      state._reservation[i]["remark"] = payload;
    }
  },
  setIsSubscribe(state, response) {
    state._subscribe = response;
  },
  setSubscribeReset(state) {
    state._subscribe = [];
  },
  setIsSubscribeAnalyzeInit(state, items) {
    state._subscribe = [];
    if (items) {
      state._subscribe = Object.assign([], items);
    }
  },
  setSubscribeAnalyze(state, items) {
    state._history = [];
    state._subscribe = items;

    if (items.history?.hasOwnProperty("gapgu") && items.history?.hasOwnProperty("eulgu")) {
      let historyArray = [];
      const dateArrayGapgu = items.history.gapgu.map(item => item);
      const dateArrayEulgu = items.history.eulgu.map(item => item);
      historyArray = historyArray.concat(dateArrayGapgu, dateArrayEulgu);

      const yearData = [];
      historyArray.forEach(item => {
        const dateMatch = item?.date?.match(/(\d{4})년(\d{1,2})월(\d{1,2})일/);
        if (dateMatch) {
          const year = dateMatch[1];
          const month = dateMatch[2];
          const day = dateMatch[3];
          const existingYearData = yearData?.find(data => data.year === year);
          if (existingYearData) {
            const existingMonthData = existingYearData?.data?.find(data => data.month === month);
            existingYearData.data.push({
              is: existingMonthData ? false : true,
              month: month,
              day: day,
              content: item?.content && item.content !== undefined && item.content !== "undefined" ? item.content : "",
              title: item?.title,
            });

            existingYearData.data.sort(function (a, b) {
              const aa = Number(a.month) + Number(a.day);
              const bb = Number(b.month) + Number(b.day);
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            });
          } else {
            yearData.push({
              year,
              data: [
                {
                  is: true,
                  month: month,
                  day: day,
                  content:
                    item?.content && item.content !== undefined && item.content !== "undefined" ? item.content : "",
                  title: item?.title,
                },
              ],
            });
          }
        }
      });
      state._history = yearData;
    }
  },
  setSubscribeAnalyzeCards(state, items) {
    state._cards = [];
    state._cards = items;
  },
  setActScore(state, item) {
    state._items.act_score = item;
  },
  [SubscribeConstant.SET_SUBSCRIBE_INFO](state, items) {
    state._info = [];
    items?.forEach(item => {
      item.selected = false;
      state._info.push(item);
    });
  },
  [SubscribeConstant.SET_SUBSCRIBE_ADDRESS_CHANGE](state, items) {
    state._addressChange = items;
  },
};

export const actions = {
  async acSubscribeReset({ commit }) {
    commit("setSubscribeReset");
  },
  async acPayment({ commit }, params) {
    const url = `/api/v1/subscribe/payment`;
    try {
      const response = await api.post(url, { ...params });
      console.log("acPayment response", response);
      console.log(commit);
      return response;
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        router.push("/");
      }
      return error.response;
    }
  },
  async acSubscribeReport({ commit }, id) {
    try {
      const url = `/api/v1/subscribe-report?id=${id}`;
      const res = await api.get(url);
      return res.data.data;
    } catch (error) {
      return false;
    } finally {
      console.log(commit);
    }
  },
  async acSubscribeAddress({ commit }) {
    try {
      const res = await api.patch(`/api/v1/subscribe`);
      return true;
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        console.log(commit);
      } else {
        return false;
      }
    }
  },
  async acIsSubscribeAnalyze({ commit }) {
    try {
      const url = `/api/v1/subscribes`;
      const res = await api.get(url);
      commit("setIsSubscribeAnalyzeInit", res.data.data);
      return true;
    } catch (error) {
      commit("setIsSubscribeAnalyzeInit", null);
      return false;
    }
  },
  async acIsSubscribeAnalyzeDetail({ commit }, analyze_seq) {
    try {
      const url = `/api/v1/subscribe/analyze?analyze_seq=${analyze_seq}`;
      const res = await api.get(url);
      // commit("setIsSubscribeAnalyze", res.data.data[0]);
      return res?.data?.data?.length > 0 ? res?.data?.data[0] : null;
    } catch (error) {
      return false;
    }
  },
  async acSubscribeAnalyzeDate({ commit }, params) {
    console.log("acSubscribeAnalyzeDate param", params);
    try {
      const res = await api.post(`/api/v1/subscribe-analyze/date`, params);
      return true;
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        console.log(commit);
      } else {
        return false;
      }
    }
  },
  async acSubscribeAnalyzeDetail({ commit }, analyze_seq) {
    try {
      const url = `/api/v1/subscribe-analyze/${analyze_seq}`;
      const res = await api.get(url);
      commit("setSubscribeAnalyze", res.data.data);
      return true;
    } catch (error) {
      return false;
    }
  },
  async acSubscribePremiumAnalyze({ commit }, { subscribe_seq, converted }) {
    try {
      const url = `/api/v1/subscribe-premium/analyze?subscribe_seq=${encodeURIComponent(subscribe_seq)}&converted=${
        converted || false
      }`;
      const res = await api.get(url);

      commit("setSubscribeAnalyze", res.data.data);
      return true;
    } catch (error) {
      return false;
    }
  },
  async acSubscribeAnalyzeCards({ commit }) {
    try {
      const url = `/api/v1/subscribe-payment/cards`;
      const res = await api.get(url);
      if (res.data?.code === 0) {
        commit("setSubscribeAnalyzeCards", res.data.data);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  },
  async acSubscribeAnalyzeUpdateCards({ dispatch }, { billing_key, uids, pg_name }) {
    try {
      if (pg_name === "kakaopay") {
        return await dispatch("portoneStore/acPortoneBillingKeyUpdate", { billing_key, uids, pg_name }, { root: true });
      } else {
        const url = `/api/v1/subscribe-payment/card`;
        const res = await api.patch(url, { billing_key, uids });
        if (res.data?.code === 0) {
          return true;
        } else {
          return false;
        }
      }
    } catch (error) {
      return false;
    }
  },
  async acSubscribeInfo({ commit }) {
    const res = await callGetApi({
      url: SubscribeAcConstant.GET_SUBSCRIBE_INFO,
      params: {},
      commit,
      errorMutation: SubscribeConstant.SET_SUBSCRIBE_ERROR,
    });

    commit(SubscribeConstant.SET_SUBSCRIBE_INFO, res);
    return true;
  },
  async acValidateAddressChange({ commit }) {
    const res = await callGetApi({
      url: SubscribeAcConstant.GET_SUBSCRIBE_ADDRESS_CHANGE,
      params: {},
      commit,
      errorMutation: SubscribeConstant.SET_SUBSCRIBE_ERROR,
    });

    commit(SubscribeConstant.SET_SUBSCRIBE_ADDRESS_CHANGE, res);
    return true;
  },
  async acSubscribeAddressChange({ commit }, payload) {
    return await callPostApi({
      url: SubscribeAcConstant.POST_SUBSCRIBE_ADDRESS_CHANGE,
      data: { ...payload },
      commit,
      errorMutation: SubscribeConstant.SET_SUBSCRIBE_ERROR,
    });
  },
  async acSubscribeReservation({ commit }, payload) {
    return await callPostApi({
      url: SubscribeAcConstant.POST_SUBSCRIBE_CANCEL_RESERVATION,
      data: payload,
      commit,
      errorMutation: SubscribeConstant.SET_SUBSCRIBE_ERROR,
    });
  },
  async acSubscribeReservationRevoke({ commit }, payload) {
    return await callPostApi({
      url: SubscribeAcConstant.POST_SUBSCRIBE_CANCEL_RESERVATION_REVOKE,
      data: payload,
      commit,
      errorMutation: SubscribeConstant.SET_SUBSCRIBE_ERROR,
    });
  },
  async acSubscribeRemoveSubscribe({ commit }, payload) {
    return await callPostApi({
      url: SubscribeAcConstant.POST_SUBSCRIBE_REMOVE_SUBSCRIBE,
      data: payload,
      commit,
      errorMutation: SubscribeConstant.SET_SUBSCRIBE_ERROR,
    });
  },
  acActScore({ commit }, item) {
    commit("setActScore", item);
  },
  acSubscribeAnalyze({ commit }, item) {
    const analyze = Object.assign({}, item);
    commit("setSubscribeAnalyze", analyze);
  },

  // ===== 프리미엄 체크리스트 =====

  // 체크리스트 조회 (before, on, after 전체)
  async acGetPremiumChecklist({ commit }, { subscribe_seq }) {
    try {
      const url = `/api/v1/subscribe-premium/checklist?subscribe_seq=${subscribe_seq}`;
      const res = await api.get(url);
      return res.data.data;
    } catch (error) {
      console.log(commit);
      return null;
    }
  },

  // 단일 항목 토글
  async acTogglePremiumChecklistItem({ commit }, { subscribe_seq, checklist_type, item_key, checked }) {
    try {
      const url = `/api/v1/subscribe-premium/checklist/toggle`;
      const res = await api.patch(url, {
        subscribe_seq,
        checklist_type,
        item_key,
        checked,
      });
      return res.data.code === 0;
    } catch (error) {
      console.log(commit);
      return false;
    }
  },

  // 공통
  /**
   * 구독 결제 버튼 클릭 시 실제 결제 이전에 구독 order 먼저 생성.
   */
  async acSubscribePaymentInit({ commit }, params) {
    try {
      const res = await api.post(`/api/v1/subscribe/payment`, params);
      window.console.log("acSubscribePaymentInit res", res);
      return true;
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        console.log(commit);
        return 401;
      } else {
        alert(
          error.response.data.code === 6010 ? "해당 주소지로 구독중인 알리미가 있습니다!" : error.response.data.message,
        );
        return false;
      }
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
